export default [
    {
        name: 'Convênios',
        url: '/gescon/gestor/convenios',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-GEST-CONV-00',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        }
    }
]
